module.exports = __webpack_public_path__ + "img/noticeBanner.0315a29a.png";